import { useParams, useNavigate } from "react-router-dom";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import MemberRecordHeartbeat from "../../member/record/heartbeat";
import MemberRecordWeight from "../../member/record/weight";
import MemberRecordSugar from "../../member/record/sugar";
import MemberRecordUncomfortable from "../../member/record/uncomfortable";
import MemberRecordHealth from "../../member/record/health";
import BackMemberSettingWork from "./work";
import BackMemberSettingDangerous from "./dangerous";
import { option_category_obj } from "../../../service/option";

export default function BackMemberDetail() {
  const route_params = useParams();
  const route_navigate = useNavigate();
  const crumbItem = [
    {
      key: 1,
      label: "會員資料管理",
      command: () => route_navigate("/back/member"),
    },
    {
      key: 2,
      label:
        option_category_obj[route_params.category][route_params.module].label,
    },
  ];

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">
        {option_category_obj[route_params.category][route_params.module].label}{" "}
        - 編輯
      </h2>

      <div className="border-round-lg bg-white mt-3 p-3">
        {route_params.module === "heartbeat" && (
          <MemberRecordHeartbeat moduleType="back_member" />
        )}
        {route_params.module === "weight" && (
          <MemberRecordWeight moduleType="back_member" />
        )}
        {route_params.module === "sugar" && (
          <MemberRecordSugar moduleType="back_member" />
        )}
        {route_params.module === "uncomfortable" && (
          <MemberRecordUncomfortable moduleType="back_member" />
        )}
        {route_params.module === "health" && (
          <MemberRecordHealth moduleType="back_member" />
        )}

        {route_params.module === "work" && <BackMemberSettingWork />}
        {route_params.module === "dangerous" && <BackMemberSettingDangerous />}
      </div>
    </>
  );
}
